export enum FontWeight {
  Light = 200, // Light
  Regular = 400, // Regular
  SemiBold = 600, // Medium
  Bold = 700, // Bold
}
